import type { IDatadogLogger } from "./DatadogLoggerTypes";

const noopLogger: IDatadogLogger = {
  debug: () => Promise.resolve(),
  info: () => Promise.resolve(),
  warn: () => Promise.resolve(),
  error: () => Promise.resolve(),
  startView: () => Promise.resolve(),
  stopView: () => Promise.resolve(),
  addRumAction: () => Promise.resolve(),
  addFeatureFlagEvaluation: () => Promise.resolve(),
  addRumError: () => Promise.resolve(),
};

let datadogLoggerImplementation = noopLogger;

export function setDatadogLoggerImplementation(logger: IDatadogLogger): void {
  datadogLoggerImplementation = logger;
}

export function resetDatadogLoggerImplementation(): void {
  datadogLoggerImplementation = noopLogger;
}

export const DatadogLogger: IDatadogLogger = {
  debug: (...args) => datadogLoggerImplementation.debug(...args),
  info: (...args) => datadogLoggerImplementation.info(...args),
  warn: (...args) => datadogLoggerImplementation.warn(...args),
  error: (...args) => datadogLoggerImplementation.error(...args),
  startView: (...args) => datadogLoggerImplementation.startView(...args),
  stopView: (...args) => datadogLoggerImplementation.stopView(...args),
  addRumAction: (...args) => datadogLoggerImplementation.addRumAction(...args),
  addFeatureFlagEvaluation: (...args) =>
    datadogLoggerImplementation.addFeatureFlagEvaluation(...args),
  addRumError: (...args) => datadogLoggerImplementation.addRumError(...args),
};
